
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import { ElNotification } from "element-plus/es";
import Item1 from "@/layout/header/partials/activity-timeline/Item1.vue";

export default defineComponent({
  name: "",
  components: {},
  setup() {
    const loading = ref(true);
    const open_reason = ref(false);
    const list = ref();
    const reason = ref("");
    const page = ref(1);
    const pagination = ref();
    const selected = ref();

    const getList = () => {
      loading.value = true;
      ApiService.get(`/admin/request-payment?page=${page.value}`).then(
        ({ data }) => {
          console.log(data);
          list.value = data.data.requests.data;
          pagination.value = data.data.requests.pagination;
          loading.value = false;
        }
      );
    };

    onMounted(() => {
      getList();
    });
    const handleCurrentChange = (val: number) => {
      page.value = val;
      getList();
    };

    const destroy = (id, type) => {
      ApiService.setHeader();
      ApiService.post(`/admin/request-payment/${id}/${type}`, {
        description: reason.value,
        amount:type === 'accept'? selected.value.amount : null
      })
        .then(() => {
          list.value = list.value.filter((item) => item.id !== id);
          ElNotification({
            title: "موفق",
            message: "وضعیت درخواست با موفقیت تغییر کرد",
            type: "success",
          });
          reason.value = ''
          open_reason.value = false;
          getList();
        })
        .catch(() => {
          ElNotification({
            title: "خطا",
            message: "خطا در تغییر وضعیت درخواست",
            type: "error",
          });
        });
    };

    return {
      list,
      loading,
      pagination,
      handleCurrentChange,
      destroy,
      open_reason,
      reason,
      selected,
    };
  },
});
